import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAgriaLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 150,
	height: 44,
	viewBox: "0 0 150 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_18208_17905)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M15.6309 0V12.1582H31.5507V43.7091H43.7072V0H15.6309Z",
					fill: "#055BA1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0 0V43.7091H28.0763V31.5509H12.1565V0H0Z",
					fill: "#055BA1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.0779 15.6309H15.6309V28.0779H28.0779V15.6309Z",
					fill: "#E20A17"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M80.7909 33.8483V34.5152H68.7395V33.8483C70.7052 33.3284 71.2986 33.1061 71.2986 32.5495C71.2986 32.2152 71.0763 31.7706 70.7804 31.0669L69.0003 26.8397H60.3971L58.729 31.3645C58.5434 31.8843 58.3947 32.2537 58.3947 32.5512C58.3947 33.2181 59.1001 33.3669 61.176 33.85V34.5169H53.4253V33.85C55.7988 33.1446 56.1331 33.1079 56.8736 31.2542C57.9483 28.5463 65.4768 8.55859 65.4768 8.55859H67.628L77.1589 31.291C77.9011 33.0711 78.4192 33.2934 80.7927 33.85L80.7909 33.8483ZM68.2196 24.9843L64.4738 16.122H64.3618L61.099 24.9843H68.2196Z",
					fill: "#055BA1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M100.865 16.2704L97.1557 17.0126C98.2672 18.0138 98.8239 19.5349 98.8239 21.6844C98.8239 26.3947 96.7094 27.4694 90.5918 27.4694C88.6628 27.4694 87.105 27.3206 85.92 27.0248C85.7712 27.8405 85.6241 28.9905 85.6241 29.5471C85.6241 30.2526 86.1055 30.7707 87.3675 30.7707H93.7827C98.0467 30.7707 99.5678 31.3273 99.5678 35.5913C99.5678 41.0052 97.6756 42.6751 93.2628 42.6751H87.441C83.3994 42.6751 82.2861 41.8594 82.2861 39.7449C82.2861 38.5214 82.9915 36.5557 84.103 35.0731C82.8428 34.4062 82.2861 33.2195 82.2861 32.143C82.2861 30.4363 82.9163 28.5459 84.7699 26.617C82.953 25.7645 82.2861 24.2067 82.2861 21.6844C82.2861 16.1584 86.2175 15.2324 90.5935 15.2324C93.3014 15.2324 97.5653 15.418 100.867 15.6035V16.2704H100.865ZM85.2898 35.4792C85.253 36.5172 85.2163 37.5937 85.2163 38.6317C85.2163 40.7462 86.0687 40.9685 88.8869 40.9685H92.0026C95.043 40.9685 95.5629 40.6341 95.5629 38.3726C95.5629 35.9256 94.8575 35.5913 91.8538 35.5913H86.6254C86.144 35.5913 85.6976 35.5545 85.2898 35.4792ZM93.2628 21.5723C93.2628 17.3819 92.6695 16.9373 90.555 16.9373C88.4405 16.9373 87.8489 17.1228 87.8489 21.5723C87.8489 25.467 88.367 25.7628 90.555 25.7628C93.002 25.7628 93.2628 25.467 93.2628 21.5723Z",
					fill: "#055BA1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M118.23 18.4214C118.23 20.2751 117.563 20.9052 115.746 20.9052C113.929 20.9052 113.224 20.2751 113.224 18.9763C113.224 18.642 113.298 18.2341 113.483 17.9383C112.445 18.0486 111.295 18.642 110.294 19.3106V31.2886C110.294 32.9935 110.406 33.1423 113.075 33.8477V34.5146H102.321V33.8477C105.029 33.1423 105.102 33.032 105.102 31.2886V18.8275C105.102 17.0841 105.029 16.9739 102.321 16.2685V15.6016H109.552V18.3462C111.258 16.2685 113.371 15.2305 115.263 15.2305C117.007 15.2305 118.23 16.1949 118.23 18.4197V18.4214Z",
					fill: "#055BA1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M119.037 33.8474C121.743 33.142 121.818 33.0317 121.818 31.2883V18.8272C121.818 17.0839 121.745 16.9736 119.037 16.2682V15.6013H127.01V31.2883C127.01 32.9932 127.122 33.142 129.792 33.8474V34.5143H119.037V33.8474ZM121.931 9.89148C121.931 8.4089 122.043 8.29688 123.525 8.29688H124.785C126.268 8.29688 126.38 8.4089 126.38 9.89148V11.1903C126.38 12.6729 126.268 12.7849 124.785 12.7849H123.525C122.043 12.7849 121.931 12.6729 121.931 11.1903V9.89148Z",
					fill: "#055BA1"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M150 33.8483V34.5152C148.406 34.7375 147.07 34.8862 145.883 34.8862C144.066 34.8862 142.806 34.5152 142.286 33.4037C141.099 34.1458 138.875 34.8862 136.65 34.8862C133.202 34.8862 131.756 33.7748 131.756 29.7681C131.756 25.7614 133.314 24.5029 137.541 24.5029H142.029V21.648C142.029 17.9389 141.77 17.7919 138.32 17.7919C136.948 17.7919 134.982 17.9039 134.982 17.9039V18.016C136.874 18.3118 137.392 18.7214 137.392 20.1672C137.392 21.613 136.65 22.763 134.796 22.763C132.943 22.763 132.237 21.8738 132.237 20.2792C132.237 16.6454 136.576 15.2363 141.434 15.2363C145.104 15.2363 147.219 17.202 147.219 20.9111V31.1842C147.219 32.9276 147.59 33.4457 150 33.8535V33.8483ZM142.027 32.3272V25.9855C137.354 26.0223 137.168 26.2813 137.168 29.6946C137.168 32.2169 137.798 32.6615 139.764 32.6615C140.506 32.6615 141.322 32.5495 142.027 32.3272Z",
					fill: "#055BA1"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_18208_17905",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 150,
				height: 43.7109,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgAgriaLogo);
export { ForwardRef as ReactComponent };
